export default __webpack_public_path__ + "static/media/ico-papeleria.20cb9c1c.svg";